





































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {MedTransGoConstants} from '../util/constants';
import '../assets/css/Settings.scss';
import '../assets/css/DataTable.scss';
import MessageBox from '../components/MessageBox.vue';
import {email, required} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import {ObjectFactory} from '../config/objectFactory';
import {
  ApiRequest,
  DeletePaymentSourceRequest,
  QueryRecordsRequest,
  UpdateGeneralSettingRequest,
  UpdateMemberRequest,
  UpdateOrgRequest,
} from '../types/request';
import {DriverProfile, InterpreterProfile, MemberProfile, TransporterProfile} from '../types/response';
import {CommonUtils} from '../util/commonUtils';
import {EventBus} from '../main';
import {ToastEvent} from '../types/event';
import DataTable from '../components/DataTable.vue';
import AddCreditCardModal from './modal/AddCreditCardModal.vue';
import AddACHCardModal from './modal/AddACHCardModal.vue';
import AddMemberModal from './modal/AddMemberModal.vue';
import AddLocationModal from './modal/AddLocationModal.vue';
import UploadLocationsModal from './modal/UploadLocationsModal.vue';
import UpdateLocationModal from './modal/UpdateLocationModal.vue';
import {BillingContact, ChequePaymentRequest, Organization, OrgLocation, Subscription} from '@/types/entity';
import {MathUtils} from '@/util/mathUtils';
import {DateUtils} from '@/util/dateUtils';
import SubscriptionModal from './modal/SubscriptionModal.vue';
import VerifyACHCardModal from './modal/VerifyACHCardModal.vue';
import SubscriptionPlanConfirmationModal from './modal/SubscriptionPlanConfirmationModal.vue';
import ViewReceiptModal from './modal/ViewReceiptModal.vue';
import BlockTransporterModal from './modal/BlockTransporterModal.vue';
import BlockInterpreterModal from './modal/BlockInterpreterModal.vue';
import AddBillingContactsModal from './modal/AddBillingContactsModal.vue';
import BlockDriverModal from '@/views/modal/BlockDriverModal.vue'; // tslint:disable-next-line: no-var-requires
// tslint:disable-next-line: no-var-requires
const CreditCardTable = require('../datatable/CreditCardTable.json');
// tslint:disable-next-line: no-var-requires
const AchTable = require('../datatable/AchTable.json');
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../config/timezones.json');
// tslint:disable-next-line: no-var-requires
const MembersTable = require('../datatable/MembersTable.json');
// tslint:disable-next-line: no-var-requires
const LocationTable = require('../datatable/LocationTable.json');
// tslint:disable-next-line: no-var-requires
const BillingAccountTable = require('../datatable/BillingAccountTable.json');
// tslint:disable-next-line: no-var-requires
const PaymentHistoryTable = require('../datatable/SubscriptionPaymentHistoryTable.json');
// tslint:disable-next-line: no-var-requires
const BlockTransporterTable = require('../datatable/BlockTransporterTable.json');
// tslint:disable-next-line: no-var-requires
const BlockInterpreterTable = require('../datatable/BlockInterpreterTable.json');
// tslint:disable-next-line: no-var-requires
const BlockDriverTable = require('../datatable/BlockDriverTable.json');
// tslint:disable-next-line: no-var-requires
const BillingContactsDataTable = require('../datatable/BillingContactsDataTable.json');

@Component({
    mixins: [validationMixin],
    data() {
        return {
            generalSettings: {
                email: '',
                timeZone: '',
            },
            memberProfile: '',
            method: 'CC',
            organization: '',
            completedRequestPercent: 0,
            requestLimit: 0,
            requestCount: 0,
            isTwoFactorEnabled: '',
            managedLocations: [],
            allData: [],
            filteredData: [],
        };
    },
    validations: {
        generalSettings: {
            timeZone: {
                required,
            },
            email: {
                email,
            },
        },
    },
    components: {
      BlockDriverModal,
        AddCreditCardModal,
        AddACHCardModal,
        DataTable,
        MessageBox,
        AddMemberModal,
        AddLocationModal,
        UpdateLocationModal,
        VerifyACHCardModal,
        SubscriptionModal,
        SubscriptionPlanConfirmationModal,
        UploadLocationsModal,
        ViewReceiptModal,
        BlockTransporterModal,
        BlockInterpreterModal,
        AddBillingContactsModal,
    },
    watch: {
        $route(to, from) {
            if (!to.path.endsWith(MedTransGoConstants.URL_ADD_MEMBER) &&
                !to.path.endsWith(MedTransGoConstants.URL_ADD_LOCATION)) {
                const settings = this as Setting;
                settings.getMemberList();
                settings.getOrganizationLocations();
            }
        },
    },
    methods: {
        togglePassword: CommonUtils.togglePassword,
    },
})
export default class Setting extends Vue {
    private memberProfile: MemberProfile | undefined;
    private subscription: Subscription = {} as any;
    private showSubscriptionInvoice = false;
    private paymentCustomerId: string = '';
    private userId = ObjectFactory.getCacheService().getSessionInfo().id;
    private subscriptionPlan: string = '';
    private invoiceLink: string | undefined = '';
    private creditCardDataSource = CreditCardTable;
    private achTableDataSource = AchTable;
    private membersDataSource = MembersTable;
    private locationsDataSource = LocationTable;
    private selectedSubscriptionPlan: string = '';
    private showSubscriptionConfirmationPlans = false;
    private showUploadLocationModal = false;
    private confirm = false;
    private paymentHistoryDataSource = PaymentHistoryTable;
    private showAddCreditCardForm = false;
    private showAddAchForm = false;
    private showVerifyACHModal = false;
    private TimeZones = TimeZones;
    private paymentSource = '';
    private showSubscriptionPlans = false;
    private blockedTransporters = BlockTransporterTable;
    private blockedInterpreters = BlockInterpreterTable;
    private blockedDrivers = BlockDriverTable;
    private showBlockTransporter = false;
    private showBlockInterpreter = false;
    private showBlockDriver = false;
    private organnizationId: string | undefined = '';
    private billingContact = {};
    private isBillingContactExist = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private billingContactsDataSource = BillingContactsDataTable;
    private orgLocations: OrgLocation[] = [];
    private allBillingContacts: any[] = [];
    private filterLocations = [];
    private updateBillingContact = false;
    private showBillingContact = false;

    private billingContactLocation: any[] = [];
    private billingContactsData: any[] | undefined = [];
    private billingLocations = [] as any;


    public async mounted() {
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (this.memberProfile.organization) {
            this.organnizationId = this.memberProfile.organization.id;
        }
        if (this.memberProfile.timezone) {
            const timeZoneMapping: Record<string, string> = {
                'America/Dawson': 'America/Los_Angeles',
                'America/Detroit': 'America/New_York',
                'America/Boise': 'America/Denver',
            };
            this.$data.generalSettings.timeZone =
                timeZoneMapping[this.memberProfile.timezone] || this.memberProfile.timezone;
        }
        await this.getOrgDetailsById();
        this.showRequestProgress();
        if ((this.memberProfile.memberType === 'ORG_ADMIN' || this.memberProfile.memberType === 'ORG_MANAGER')
            && this.$data.organization && (!this.$data.organization.chequePaymentRequest
            || this.$data.organization.chequePaymentRequest.status !== 'Approved')) {
            if (this.memberProfile.paymentCustomerId && (this.memberProfile.memberType === 'ORG_ADMIN'
                || this.memberProfile.memberType === 'ORG_MANAGER')) {
                this.paymentCustomerId = this.memberProfile.paymentCustomerId;
                this.getListPaymentSource('bank_account');
                this.getListPaymentSource('card');
            }
        }
        if (this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER' && this.memberProfile.memberPaymentCustomerId) {
            this.paymentCustomerId = this.memberProfile.memberPaymentCustomerId;
        }
        if (this.memberProfile.memberType !== 'ORG_CUSTOMER') {
            if (this.memberProfile.memberType === 'ORG_ADMIN') {
                this.getMemberList('', 0);
                this.getSubscriptionPlan();
            } else if (this.memberProfile.memberType === 'ORG_MANAGER') {
                this.getMemberList('', 0);
            }
            this.getOrganizationLocations();
        }
        if (this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER') {
            if (!this.memberProfile.parentMemberId) {
                const tableData = JSON.parse(JSON.stringify(MembersTable));
                tableData.actions = tableData.actions.filter((action: any) => {
                    return !['Make admin', 'Disable Notification', 'Enable Sms Notification'].includes(action.label);
                });
                this.membersDataSource = tableData;
            }
            this.getMemberList('', 0);
        }
        if (!this.paymentCustomerId && this.memberProfile.memberType === 'ORG_ADMIN'
            && this.memberProfile.paymentCustomerId) {
            this.paymentCustomerId = this.memberProfile.paymentCustomerId;
        }
        this.getTransportersList();
        this.getDriverList();
        this.getListPaymentSource('bank_account');
        this.getListPaymentSource('card');
    }

    private getBillingContacts(billingContacts: BillingContact[]) {
        this.billingContactsDataSource.data = billingContacts;
        this.$data.allData = billingContacts;
    }

    private async saveSettings() {
        const userId = ObjectFactory.getCacheService().getSessionInfo().id;
        const updateGeneralSettingRequest: UpdateGeneralSettingRequest = {
            timeZone: this.$data.generalSettings.timeZone,
        };
        const response = await ObjectFactory.getMemberService().updateMemberSettings(this.$store.state.serverUrl,
            userId, updateGeneralSettingRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_SAVE_SETTING'),
                title: 'General Settings',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            if (this.memberProfile && this.memberProfile.location && this.memberProfile.location.settings) {
                this.memberProfile.timezone = this.$data.generalSettings.timeZone;
                ObjectFactory.getCacheService().saveValue(MedTransGoConstants.FIELD_MEMBER_PROFILE, this.memberProfile);
            }
        } else {
            CommonUtils.showError(response);
        }
    }


    private logout() {
        CommonUtils.logout(this.$store.state);
    }

    private goBack() {
        this.$router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
    }

    private async getListPaymentSource(paymentMethod: 'bank_account' | 'card') {
        this.creditCardDataSource.data = [];
        this.achTableDataSource.data = [];
        const locationsResponse = await ObjectFactory.getOrganizationService()
                    .getLocations(this.$store.state.serverUrl);
        let locationIds = [] as any;
        if (locationsResponse.success && locationsResponse.data) {
            if (this.memberProfile && this.memberProfile.memberType === 'ORG_MANAGER') {
                if (this.memberProfile.managedLocations && this.memberProfile.managedLocations.length > 0) {
                    locationIds = this.memberProfile.managedLocations.map((loc: any) => loc.id);
                    this.billingLocations = this.memberProfile.managedLocations;
                } else {
                    locationIds = [];
                }
            } else  if (this.memberProfile && this.memberProfile.memberType === 'ORG_ADMIN') {
                locationIds = locationsResponse.data.map((loc: any) => loc.id);
                this.billingLocations = locationsResponse.data;

            }
        }
        const response = await ObjectFactory.getPaymentSourceService().getListPaymentSource(paymentMethod,
            this.$store.state.serverUrl, '', locationIds);
        const defaultSourceResponse = await ObjectFactory.getPaymentSourceService().
            getPaymentCustomer(this.$store.state.serverUrl);
        const defaultSource = defaultSourceResponse.data.defaultSource;
        if (response.success) {
            if (paymentMethod === 'card' && response.data) {
                for (const element of response.data) {
                    const month = element.exp_month > 9 ? element.exp_month : '0' + element.exp_month;
                    element.expires = `${month}/${element.exp_year}`;
                    element.defaultSource = (element.id === defaultSource.id);

                    const billingLocationIds: string[] = element.metadata && element.metadata.billingLocationIds
                        ? JSON.parse(element.metadata.billingLocationIds)
                        : [];
                    let locationNames: string[] = [];
                    if (billingLocationIds.length > 0) {
                        const promises = billingLocationIds.map(async (locId: string) => {
                            const locResponse = await ObjectFactory.getOrganizationService()
                                .getLocationDetails(this.$store.state.serverUrl, locId);
                            if (locResponse && locResponse.data && locResponse.data.locationName) {
                                return locResponse.data.locationName;
                            }
                            return '';
                        });
                        locationNames = await Promise.all(promises);
                    }

                    element.billingLocationName = locationNames.filter((n) => n).join(', ');
                }
                this.creditCardDataSource.perPage = response.data.length;
                this.creditCardDataSource.data = response.data;
            } else {
                for (const element of response.data) {
                    element.defaultSource = (element.id === defaultSource.id);
                    if (element.status === 'verified') {
                        element.displayStatus = 'Verified';
                    } else if (element.status === 'new') {
                        element.displayStatus = 'Pending Verification';
                    } else if (element.status === 'verification_failed') {
                        element.displayStatus = 'Verification Failed';
                    }
                    const billingLocationIds: string[] = element.metadata && element.metadata.billingLocationIds
                        ? JSON.parse(element.metadata.billingLocationIds)
                        : [];
                    let locationNames: string[] = [];
                    if (billingLocationIds.length > 0) {
                        const promises = billingLocationIds.map(async (locId: string) => {
                            const locResponse = await ObjectFactory.getOrganizationService()
                                .getLocationDetails(this.$store.state.serverUrl, locId);
                            if (locResponse && locResponse.data && locResponse.data.locationName) {
                                return locResponse.data.locationName;
                            }
                            return '';
                        });
                        locationNames = await Promise.all(promises);
                    }

                    element.billingLocationName = locationNames.filter((n) => n).join(', ');
                }
                this.achTableDataSource.perPage = response.data.length;
                this.achTableDataSource.data = response.data;
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private async deletePaymentSource(paymentSource: any) {
        const iHttpService = ObjectFactory.getHttpService();
        const deletePaymentSourceRequest: DeletePaymentSourceRequest = {
            customerId: paymentSource.customer,
            paymentSourceId: paymentSource.id,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PAYMENT_SOURCE}`,
            data: deletePaymentSourceRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.delete<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_DELETE_PAYMENT_SOURCE'),
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            this.getListPaymentSource('bank_account');
            this.getListPaymentSource('card');
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private async setPrimaryPaymentSource(paymentSource: any) {
        const response = await ObjectFactory.getPaymentSourceService().setDefaultPaymentSource(paymentSource.id,
            this.$store.state.serverUrl);
        this.getListPaymentSource('bank_account');
        this.getListPaymentSource('card');
    }

    private async getMemberList(searchString?: string, start?: number) {
        const response = await ObjectFactory.getMemberService()
            .getMemberList(this.$store.state.serverUrl, searchString, start);
        if (response.success && response.data) {
            this.membersDataSource.data = response.data;
            response.data.forEach((element) => {
                if (this.memberProfile) {
                    element.sessionUserType = this.memberProfile.memberType;
                }
                if (!element.notificationDisabled) {
                    element.notificationDisabled = false;
                }
            });
            if (response.totalCount) {
                this.membersDataSource.totalCount = response.totalCount;
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private async enableOrDisableNotification(memberProfile: any, notificationDisabled: boolean) {
        const iHttpService = ObjectFactory.getHttpService();
        const updateMemberRequest: UpdateMemberRequest = {
            notificationDisabled,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_MEMBERS}/${memberProfile.memberId}`,
            data: updateMemberRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<MemberProfile>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Notification has been ${notificationDisabled ? 'disabled' : 'enabled'}`,
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.getMemberList();
        } else {
            CommonUtils.showError(response);
        }
    }

    private showAddMemberForm() {
        this.$router.push({ name: MedTransGoConstants.VIEW_ADD_MEMBER_NAME });
    }

    private showAddChildMemberForm() {
        this.$router.push({ name: 'AddChildMemberModal' });
    }

    private showUpdateMemberForm(member: MemberProfile) {
        this.$router.push({ append: true, path: `${MedTransGoConstants.URL_UPDATE_MEMBER}/${member.memberId}` });
    }

    private showAddLocationForm() {
        this.$router.push({ name: MedTransGoConstants.VIEW_ADD_LOCATION_NAME });
    }

    private showUpdateLocationForm(oragnazation: OrgLocation) {
        this.$router.push({ append: true, path: `${MedTransGoConstants.URL_UPDATE_LOCATION}/${oragnazation.id}` });
    }

    private showUploadLocationForm() {
        this.showUploadLocationModal = true;
    }

    private showBlockTransporterForm() {
        this.showBlockTransporter = true;
    }

  private showBlockDriverForm() {
    this.showBlockDriver = true;
  }

    private showBlockInterpreterForm() {
        this.showBlockInterpreter = true;
    }

    /**
     * @author <Aniket.P>
     * @description API - Returns organization locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of locations
     * @returns List of oragnazation lists
     * @throws InvalidRequestException if organization id is invalid
     */
    private async getOrganizationLocations() {
        const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (response.success && response.data) {
            if (this.memberProfile && this.memberProfile.isCaseManager) {
                this.locationsDataSource = BillingAccountTable;
            }
            const billingContacts = this.billingContactsData || [];
            response.data.forEach((location, index) => {
                const contactNames = billingContacts
                .filter((contact) => contact.billingLocationIds.includes(location.id))
                .map((contact) => contact.name || 'Unknown Contact');

                location.billingContacts = contactNames.length > 0 ? contactNames.join(', ') : 'Unassigned';
            });
            response.data.sort((a, b) =>
                (a.locationName || '').localeCompare(b.locationName || ''),
            );
            this.locationsDataSource.data = response.data;
            this.locationsDataSource.perPage = response.data.length;
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getOrgDetailsById() {
        const response = await ObjectFactory.getOrganizationService().getOrgDetailsById(this.$store.state.serverUrl);
        if (response.success && response.data) {
            this.$data.organization = response.data;
            if (response.data.locations) {
                response.data.locations.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
                this.orgLocations = response.data.locations;
                this.billingContactLocation = response.data.locations;
                this.billingContactsData = response.data.billingContacts;
                if (response.data.billingContacts) {
                    this.getBillingContacts(response.data.billingContacts);
                }
            }
            if (this.$data.organization.chequePaymentRequest) {
                this.$data.organization.chequePaymentRequest.approvedOn =
                    this.$data.organization.chequePaymentRequest.approvedOn ?
                        DateUtils.formatDate(this.$data.organization.chequePaymentRequest.approvedOn) : '-';
                const user = await ObjectFactory.getUserService().
                    getUserById(this.$data.organization.chequePaymentRequest.requestedBy,
                        this.$store.state.serverUrl);
                if (user.data) {
                    this.$data.organization.chequePaymentRequest.requestedBy = user.data.fullname;
                }
            }
            this.$data.isTwoFactorEnabled = response.data.twoFactorAuthenticationEnabled;
            this.billingContact = response.data.billingContact;
            if (response.data.billingContact && response.data.billingContact.email) {
                this.isBillingContactExist = true;
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private async enableChequePayment() {
        const userId = ObjectFactory.getCacheService().getSessionInfo().id;
        const organnizationId = this.$data.organization.id;
        const chequePaymentRequest: ChequePaymentRequest = {
            requestedBy: userId,
            status: 'Pending',
        };
        const updateOrgRequest = {
            chequePaymentRequest,
        };
        const response = await ObjectFactory.getOrganizationService().updateOrganization(this.$store.state.serverUrl,
            organnizationId, updateOrgRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Your request to enable check payment has been submitted. It will be enabled once approved by operation team`,
                title: 'Message',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.getOrgDetailsById();
        } else {
            CommonUtils.showError(response);
        }
    }
    private async deleteMember(member: MemberProfile) {
        const response = await ObjectFactory.getMemberService().deleteMember(this.$store.state.serverUrl, member);
        if (response.success) {
            this.getMemberList();
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_DEACTIVATE_MEMBER'),
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private async makeAdmin(member: MemberProfile) {
        const updateMemberRequest: UpdateMemberRequest = {
            fullname: member.fullname,
            email: member.email,
            phone: member.phone,
            memberType: 'ORG_ADMIN',
        };
        if (member.location) {
            updateMemberRequest.location = member.location.id;
        }
        const response = await ObjectFactory.getMemberService().updateMember(this.$store.state.serverUrl,
            member.memberId, updateMemberRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_SET_MEMBER_ADMIN'),
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            this.getMemberList('', 0);
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getTransportersList() {
        const organization = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organization.data && organization.data.blockedTransporters) {
            const queryRecordsRequest: QueryRecordsRequest = {
                conditions: [{
                    op: 'in',
                    fieldName: 'userId',
                    value: organization.data.blockedTransporters,
                }],
                limit: MedTransGoConstants.DB_QUERY_MAX_RESULT,
            };
            const response = await ObjectFactory.getTransporterService()
                .getTransporterList(this.$store.state.serverUrl, queryRecordsRequest);
            if (response.success && response.data) {
                this.blockedTransporters.data = response.data;
            }
        }
    }

  private async getDriverList() {
    const organization = await ObjectFactory.getOrganizationService().getOrgDetailsById(this.$store.state.serverUrl);
    if (organization.data && organization.data.blockedDrivers) {
      const queryRecordsRequest: QueryRecordsRequest = {
        conditions: [{
          op: 'in',
          fieldName: 'userId',
          value: organization.data.blockedDrivers,
        }],
        limit: MedTransGoConstants.DB_QUERY_MAX_RESULT,
      };
      const response = await ObjectFactory.getDriverService()
          .getDriverList(this.$store.state.serverUrl, queryRecordsRequest);
      if (response.success && response.data) {
        this.blockedDrivers.data = response.data;
      }
    }
  }

    private async getInterpreterList() {
        const organization = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organization.data && organization.data.blockedInterpreters) {
            const queryRecordsRequest: QueryRecordsRequest = {
                conditions: [{
                    op: 'in',
                    fieldName: 'userId',
                    value: organization.data.blockedInterpreters,
                }],
                limit: MedTransGoConstants.DB_QUERY_MAX_RESULT,
            };
            const response = await ObjectFactory.getInterpreterService()
                .getInterpreterList(this.$store.state.serverUrl, queryRecordsRequest);
            if (response.success && response.data) {
                this.blockedInterpreters.data = response.data;
            }
        }
    }

    private async unblockTransporter(transporterProfile: TransporterProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const updateRequest: UpdateOrgRequest = {
            unblockTransporterId: transporterProfile.id,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.organnizationId}/update`,
            data: updateRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<Organization>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Transporter Unblocked successfully..',
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.getTransportersList();
        } else {
            CommonUtils.showError(response);
        }
    }

  private async unblockDriver(driverProfile: DriverProfile) {
    const iHttpService = ObjectFactory.getHttpService();
    const updateRequest: UpdateOrgRequest = {
      unblockDriverId: driverProfile.id,
    };
    const apiRequest: ApiRequest = {
      baseURL: this.$store.state.serverUrl,
      url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.organnizationId}/update`,
      data: updateRequest,
      loaderEvent: {
        show: true,
      },
    };
    const response = await iHttpService.put<Organization>(apiRequest);
    if (response.success) {
      const toastEvent: ToastEvent = {
        message: 'Driver Unblocked successfully!',
        title: 'Success!',
        timeout: 2000,
        varient: 'success',
      };
      EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
      await this.getDriverList();
    } else {
      CommonUtils.showError(response);
    }
  }

    private async enableDisableTwoFactorAuthentication() {
        const iHttpService = ObjectFactory.getHttpService();
        const updateRequest: UpdateOrgRequest = {
            twoFactorAuthenticationEnabled: this.$data.isTwoFactorEnabled,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.organnizationId}/update`,
            data: updateRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<Organization>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Two Factor Authentication Updated Successfully',
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private async unblockInterpreter(interpreterProfile: InterpreterProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const updateRequest: UpdateOrgRequest = {
            unblockInterpreterId: interpreterProfile.id,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.organnizationId}/update`,
            data: updateRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<Organization>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Interpreter Unblocked successfully..',
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.getInterpreterList();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async verifyAchAccount(paymentSource: any) {
        this.showVerifyACHModal = true;
        this.paymentSource = paymentSource.id;
    }
    private async getSubscriptionPlan() {
        if (this.memberProfile) {
            this.subscriptionPlan = this.memberProfile.subscriptionPlan as any;
        }
        const response = await ObjectFactory.getSubscriptionService().getSubscription(this.$store.state.serverUrl);
        if (response.success && response.data) {
            response.data.paymentHistory.forEach((element) => {
                element.subscriptionAmount = MathUtils.formatCurrency(element.amount);
                element.subscriptionDate = DateUtils.formatDate(element.timestamp);
                element.startDate = DateUtils.formatDate(element.startDate, DateUtils.FORMATE_DATE);
                element.endDate = DateUtils.formatDate(element.endDate, DateUtils.FORMATE_DATE);
                if (element.paymentResponse && element.paymentResponse.paymentMethod) {
                    const paymentMethod = element.paymentResponse.paymentMethod;
                    element.paymentResponse.paymentMethod = `${paymentMethod.type === 'card' ? 'Card' : 'check' ? 'Check Payment' : 'Bank Account'} Ending with **** ${paymentMethod.card ? paymentMethod.card.last4 : 'NA'}`;
                }
            });
            this.subscriptionPlan = response.data.plan;
            response.data.startDate = DateUtils.formatDate(response.data.startDate, DateUtils.FORMATE_DATE) as any;
            response.data.endDate = DateUtils.formatDate(response.data.endDate, DateUtils.FORMATE_DATE) as any;
            this.subscription = response.data;
            this.paymentHistoryDataSource.data = response.data.paymentHistory;
            this.paymentHistoryDataSource.perPage = response.data.paymentHistory.length;
        } else {
            CommonUtils.showError(response);
        }
    }

    private async viewReceipt(payment?: any) {
        if (payment) {
            window.open(payment.paymentResponse.receiptUrl, 'Payment Receipt', 'width=600,height=800');
        }
    }

    private async viewInvoice(transaction?: any) {
        if (transaction) {
            this.invoiceLink = transaction.invoiceLink;
            this.showSubscriptionInvoice = true;
        }
    }

    private async changePlan() {
        this.showSubscriptionPlans = true;
    }

    private async activateSubscriptionPlan(plan: 'FREE' | 'STANDARD' | 'TELEMEDICINE' | 'STANDARD_PLUS') {
        this.showSubscriptionPlans = false;
        await ObjectFactory.getSubscriptionService().activateSubscriptionPlan(plan, this.$store.state.serverUrl);
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        this.memberProfile.subscriptionPlan = plan;
        ObjectFactory.getCacheService().saveValue(MedTransGoConstants.FIELD_MEMBER_PROFILE, this.memberProfile);
        this.getSubscriptionPlan();
    }

    private setPlan(selectedPlan: string) {
        if (this.subscriptionPlan !== selectedPlan) {
            this.selectedSubscriptionPlan = selectedPlan;
            this.showSubscriptionConfirmationPlans = true;
        }
        this.showSubscriptionPlans = false;
    }

    private async showRequestProgress() {
        const response = await ObjectFactory.getOrganizationService().
            getOrganizationRequestCount(this.$store.state.serverUrl);
        if (response.data) {
            this.$data.completedRequestPercent = (response.data.comletedRequestCount / response.data.limit) * 100;
            this.$data.requestLimit = response.data.limit;
            this.$data.requestCount = response.data.comletedRequestCount;
        }
    }

    private async showBillingContactsForm() {
        this.showBillingContact = true;
        this.updateBillingContact = false;
    }

    private updateBillingContactDataSource() {
        const uniqueContacts: BillingContact[] = [];
        if (this.$data.managedLocations && this.$data.managedLocations.length > 0) {
            this.$data.managedLocations.forEach((location: any) => {
                const matchingContacts = this.$data.allData.filter((contact: BillingContact) =>
                    contact.billingLocationIds.includes(location.id),
                );

                matchingContacts.forEach((contact: BillingContact) => {
                    if (!uniqueContacts.some((c) => c.id === contact.id)) {
                        uniqueContacts.push(contact);
                    }
                });
            });
            this.billingContactsDataSource.data = uniqueContacts;
        } else {
            this.billingContactsDataSource.data = this.$data.allData;
        }
    }

    private async showUpdateBillingContactForm(billingContact: BillingContact) {
        this.billingContact = billingContact;
        this.updateBillingContact = true;
        this.showBillingContact = true;
    }

}
